/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="../../components/baseclasses/guid.ts" />
/// <reference path="../../components/models/meevo.model.custom.ts" />

module Meevo.Plugins.MemberBenefitTemplates {
  "use strict";

  import BenefiteTemplateUpdateItemTypeEnum = Meevo.Components.Controls.BenefiteTemplateUpdateItemTypeEnum;

  export class MemberBenefitTemplatesContext extends Meevo.Components.BaseClasses.DataMaintenanceContextBase {

    private MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES_READ: Model.SecurityAccessEnum;
    private MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES_WRITE: Model.SecurityAccessEnum;

    constructor(appSettings: Meevo.Components.Common.IAppSettings,
      dataService: Meevo.Components.BaseClasses.IDataService,
      modalService: Meevo.Components.Modal.IModalService,
      identityService: Meevo.Components.Common.IIdentityService,
      loggingService: Meevo.Components.Logging.ILoggingService,
      securityChecker: Meevo.Components.Common.ISecurityService,
      trackingService: Meevo.Components.Tracking.ITrackingService,
      protected busyService: Meevo.Components.Busy.IBusyService,
      protected $scope: ng.IScope) {

      super(appSettings, dataService, modalService, identityService, loggingService, securityChecker, trackingService);
        
      this.baseEndpoint = appSettings.API_ENDPOINTS.memberBenefitTemplates;
      this.sectionTemplatePath = "app/plugins/memberBenefitTemplates/sectionViews/";
        
      this.buildCrudSecurityKeys(this.securityKeys.MEMBERSHIP_MEMBERBENEFITTEMPLATE_TAB_MAIN);
      this.entityType = 'MemberBenefitTemplate';
      this.$scope.$watch( ()=> {
          this.isLoading ? this.busyService.start() : this.busyService.stop();
      });

        this.busyService.start();

        this.securityChecker.checkSecurityItem(this.securityKeys.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES + Meevo.Components.Common.SecurityParts.KEY_PART_READ).then((item: Model.SecurityItem) => {
            this.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES_READ = item.securityAccess;

            this.securityChecker.checkSecurityItem(Meevo.Components.Common.SecurityKeys.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES + Meevo.Components.Common.SecurityParts.KEY_PART_WRITE).then((item: Model.SecurityItem) => {
                this.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES_WRITE = item.securityAccess;

                this.busyService.stop();
            });
            
        });   
    }

      initializeSections(): void {
          if (this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MEMBERSHIP_MEMBERBENEFITTEMPLATE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ)) {
              this.sections.push(new MainSection(0, "SECTION_MEMBERBENEFITTEMPLATE_MAIN", "main.html", true, false, this.appSettings.API_ENDPOINTS.memberBenefitTemplates, "",
                  this.loggingService, this.dataService, this.identityService, Meevo.Model.NounEnum.MemberBenefitTemplateMain, null, this.securityKeys.MEMBERSHIP_MEMBERBENEFITTEMPLATE_TAB_MAIN + Meevo.Components.Common.SecurityParts.KEY_PART_READ));
          }
      }

      initializeHeader(model: any): void {
          this.headerContent = model.displayName;
          this.businessTypeDetail = model.businessTypeDetail;
      }

      isMarketPricingButtonVisible() {
          return this.isReadonly && this.isApplicationModeCO() && this.isMarketPricingEnabled()
              && this.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES_READ != Model.SecurityAccessEnum.Hide;
      }

      isMarketPricingButtonDisabled() {
          return !(this.isReadonly && this.isApplicationModeCO() && this.isMarketPricingEnabled()
              && this.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES_READ == Model.SecurityAccessEnum.Grant);
      }

      isMarketPricingEnabled() {
          return this.securityChecker.hasSecurityDenyOrGrant(this.securityKeys.MANAGEMENT_MARKETPRICING + Meevo.Components.Common.SecurityParts.KEY_PART_READ)
      }

      showEmptyModal(displayName: string, prefix: string) {
          const options = this.createModalOptions({}, null, displayName, prefix, null, true);

          this.modalService.showCustom(options);
      }

      openMarketsModalForProductsOverall() {
          if (!this.isReadonly) {
              return
          }

          let model = this.castModel<Model.MemberBenefitTemplate>();

          if (this.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES_WRITE == Model.SecurityAccessEnum.Hide) {
              this.showEmptyModal(model.displayName, null);
              return;
          }

          this.dataService.customMethodData("api/MemberBenefitTemplate/" + model.id + "/MarketPricing/Overall", "GET", null).then((res) => {
              let data = res.data;
              if (data) {

                  data.forEach(function (pg) {
                      pg.value = pg.productDiscount;
                  });

                  const options = this.createModalOptions(data, model.id, model.displayName, null, BenefiteTemplateUpdateItemTypeEnum.ProductOverall, true);

                  this.modalService.showCustom(options).then((res) => {
                      if (res && res.defaultMarket) {
                          model.productDiscount = res.defaultMarket.value;
                      }
                  });
              }
          });
      }

      openMarketsModalForServicesOverall() {
          if (!this.isReadonly) {
              return
          }

          let model = this.castModel<Model.MemberBenefitTemplate>();

          if (this.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES_WRITE == Model.SecurityAccessEnum.Hide) {
              this.showEmptyModal(model.displayName, null);
              return;
          }

          this.dataService.customMethodData("api/MemberBenefitTemplate/" + model.id + "/MarketPricing/Overall", "GET", null).then((res) => {
              let data = res.data;
              if (data) {

                  data.forEach(function (pg) {
                      pg.value = pg.serviceDiscount;
                  });

                  const options = this.createModalOptions(data, model.id, model.displayName, null, BenefiteTemplateUpdateItemTypeEnum.ServiceOverall, true);

                  this.modalService.showCustom(options).then((res) => {
                      if (res && res.defaultMarket) {
                          model.serviceDiscount = res.defaultMarket.value;
                      }
                  });
              }
          });
      }

      openMarketsModalForPackagesOverall() {
          if (!this.isReadonly) {
              return
          }

          let model = this.castModel<Model.MemberBenefitTemplate>();

          if (this.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES_WRITE == Model.SecurityAccessEnum.Hide) {
              this.showEmptyModal(model.displayName, null);
              return;
          }

          this.dataService.customMethodData("api/MemberBenefitTemplate/" + model.id + "/MarketPricing/Overall", "GET", null).then((res) => {
              let data = res.data;
              if (data) {

                  data.forEach(function (pg) {
                      pg.value = pg.packageDiscount;
                  });

                  const options = this.createModalOptions(data, model.id, model.displayName, null, BenefiteTemplateUpdateItemTypeEnum.PackageOverall, true);

                  this.modalService.showCustom(options).then((res) => {
                      if (res && res.defaultMarket) {
                          model.packageDiscount = res.defaultMarket.value;
                      }
                  });
              }
          });
      }

      openMarketsModalForProduct(productItem: any) {
          if (!this.isReadonly) {
              return
          }

          let model = this.castModel<Model.MemberBenefitTemplate>();

          if (this.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES_WRITE == Model.SecurityAccessEnum.Hide) {
              this.showEmptyModal(productItem.displayName, productItem.variantDisplayName);
              return;
          }

          this.dataService.customMethodData("api/MemberBenefitTemplate/" + model.id + "/MarketPricing/Product", "GET", null, { productVariantId: productItem.id }).then((res) => {
              let data = res.data;
              if (data) {

                  data.forEach(function (pg) {
                      pg.value = pg.discountAmount;
                  });

                  const options = this.createModalOptions(data, productItem.id, productItem.displayName, productItem.variantDisplayName, BenefiteTemplateUpdateItemTypeEnum.ProductItem);

                  this.modalService.showCustom(options).then((res) => {

                      if (res && res.defaultMarket) {
                          const defaultMarket = model.productListDiscounts.find((item) => item.id == res.defaultMarket.itemId)
                          defaultMarket.discountAmount = res.defaultMarket.value;
                          defaultMarket.isPercent = res.defaultMarket.isPercent;
                      }
                  });
              }
          });


      }

      openMarketsModalForService(serviceItem: any) {
          if (!this.isReadonly) {
              return
          }

          let model = this.castModel<Model.MemberBenefitTemplate>();

          if (this.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES_WRITE == Model.SecurityAccessEnum.Hide) {
              this.showEmptyModal(serviceItem.displayName, serviceItem.shortCut);
              return;
          }

          this.dataService.customMethodData("api/MemberBenefitTemplate/" + model.id + "/MarketPricing/Service", "GET", null, { serviceId: serviceItem.id }).then((res) => {
              let data = res.data;
              if (data) {

                  data.forEach(function (pg) {
                      pg.value = pg.discountAmount;
                  });

                  const options = this.createModalOptions(data, serviceItem.id, serviceItem.displayName, serviceItem.shortCut, BenefiteTemplateUpdateItemTypeEnum.ServiceItem);

                  this.modalService.showCustom(options).then((res) => {

                      if (res && res.defaultMarket) {
                          const defaultMarket = model.serviceListDiscounts.find((item) => item.id == res.defaultMarket.itemId)
                          defaultMarket.discountAmount = res.defaultMarket.value;
                          defaultMarket.isPercent = res.defaultMarket.isPercent;
                      }
                  });
              }
          });
      }

      openMarketsModalForPackage(packageItem: any) {
          if (!this.isReadonly) {
              return
          }

          let model = this.castModel<Model.MemberBenefitTemplate>();

          if (this.MANAGEMENT_MARKETPRICING_TAB_MEMBERBENEFITTEMPLATES_WRITE == Model.SecurityAccessEnum.Hide) {
              this.showEmptyModal(packageItem.displayName, null);
              return;
          }

          this.dataService.customMethodData("api/MemberBenefitTemplate/" + model.id + "/MarketPricing/Package", "GET", null, { packageId: packageItem.id }).then((res) => {
              let data = res.data;
              if (data) {

                  data.forEach(function (pg) {
                      pg.value = pg.discountAmount;
                  });

                  const options = this.createModalOptions(data, packageItem.id, packageItem.displayName, null, BenefiteTemplateUpdateItemTypeEnum.PackageItem);

                  this.modalService.showCustom(options, null).then((res) => {

                      if (res && res.defaultMarket) {
                          const defaultMarket = model.packageListDiscounts.find((item) => item.id == res.defaultMarket.itemId)
                          defaultMarket.discountAmount = res.defaultMarket.value;
                          defaultMarket.isPercent = res.defaultMarket.isPercent;
                      }
                  });
              }
          });
      }

      createModalOptions(data: any, selectedItemId: string, displayName: string, prefix: string, updateItemType: BenefiteTemplateUpdateItemTypeEnum, restrictToPercent?: boolean): Meevo.Components.Modal.IModalOptions {
          let model = this.castModel<Model.MemberBenefitTemplate>();

          const options: Meevo.Components.Modal.IModalOptions = {
              templateUrl: "app/components/controls/marketPricing/itemMarkets.template.html",
              controller: "meevo.components.controls.marketPricing.ItemMarketsController",
              controllerAs: "vm",
              bindToController: true,
              locals: {
                  options: {
                      data,
                      selectedItemId: selectedItemId,
                      displayName: displayName,
                      isPercentOnly: restrictToPercent,
                      itemShortcut: prefix,
                      updateType: updateItemType,
                      memberBenefitTemplateId: model.id
                  }
              }
          }

          return options;
      }

  }
}